import React from 'react';
import {connect} from 'react-redux';
import dotProp from 'dot-prop';
import isFunction from 'lodash/isFunction';
import compose from 'recompose/compose';
import catchErrors from './catchErrors';
import {saveResourceFieldAction, saveResourceFieldErrorAction} from 'resources/actions';
import {extractResourceIdsWithPath, isNoU, isTruthy, TopLevelSectionName} from 'utils/DBUtils';

const getFieldErrors = (errors, id, field) => {
    const errorsObj = errors[id + field];
    if (!isNoU(errorsObj)) {
        if (errorsObj.errorCode === 'INVALID_VALUE') {
            return errorsObj.failedValidations.map(validationError => ({
                key: `errors.validation.${validationError.name}`,
                type: validationError.name,
                invalidValues: validationError.invalidValues
            }));
        } else {
            return [{key: `errors.${errorsObj.errorCode}`}];
        }
    }
};

const resourceField = ({resource, fieldPath, resourcePath, autoPopulate, showExtraContent, showField, formProxy, field, reducerKey, sectionKeyPath}, FieldComponent) => {

    const fieldJoinPath = fieldPath.join('.');
    const lastField = fieldPath[fieldPath.length - 1];

    const mapStateToProps = (state) => {
        const rootResource = state.resources.resources[resource.id];
        const value = dotProp.get(rootResource, fieldJoinPath);
        const errors = getFieldErrors(state.resources.saveErrors, resource.resourceId.id, lastField) || [];
        const isSaving = isTruthy(state.resources.pendingSaves[resource.resourceId.id + lastField]);
        const savedField = Boolean(state.resources.savedField[resource.resourceId.id + lastField]);

        let props = {
            value,
            errors,
            isSaving,
            savedField
        };

        if (isFunction(field.editable)) {
            props.editable = field.editable(formProxy);
        }

        if (showField) {
            props.showField = isTruthy(showField(formProxy));
        }

        if (isFunction(autoPopulate)) {
            let auto = autoPopulate(formProxy);
            if (typeof(auto) !== 'undefined' && auto !== value) {
                props.value = auto;
            }
        }

        if (showExtraContent) {
            props.showExtraContent = showExtraContent(formProxy);
        }

        if (isFunction(field.disabled)) {
            props.disabled = field.disabled(formProxy);
        }

        return props;
    };

    const mapDispatchToProps = dispatch => ({
        onValueChanged: (value, field, errors) => {
            const {resourceId} = resource;
            // No master for this type of field
            if (isNoU(errors) || errors.length === 0) {
                const parentIds = extractResourceIdsWithPath(resource, resource, resourcePath);
                dispatch(saveResourceFieldAction(resourceId, resourceId, resourcePath, fieldPath, lastField, value, parentIds, [], []));
            }
        },
        onValidationSuccess: (name, platform) => {},
        onValidationError: (name, rule, platform) => {// Set which resource was actually modified
            let modifiedResource = resource[platform];
            let modifiedResourceId = resource.resourceId;
            if (resourcePath.length > 0) {
                // If there is a resource path then the edited resource is at the end of that path
                modifiedResource = dotProp.get(modifiedResource, resourcePath.join('.'));
                if (!modifiedResource) {
                    console.error("Cannot raise error on null resource", modifiedResource, resourcePath);
                    return;
                }
            }

            modifiedResourceId = modifiedResource.resourceId;
            if (!modifiedResourceId) {
                console.error("Cannot raise error on null resourceId", modifiedResource);
                return;
            }

            dispatch(saveResourceFieldErrorAction(modifiedResourceId.id, name, null, {
                errorCode: "INVALID_VALUE",
                failedValidations: rule.map(item => ({name: item.type})),
                sectionKeyPath: sectionKeyPath
            }, resource[platform].resourceId, fieldPath));
        }
    });

    const ConnectedComponent = compose(
        catchErrors,
        connect(mapStateToProps, mapDispatchToProps)
    )(FieldComponent);

    ConnectedComponent.displayName = "ResourceField";

    return ConnectedComponent;
};

export default resourceField;



// WEBPACK FOOTER //
// ./public/hoc/ResourceField.jsx